// removed by extract-text-webpack-plugin
module.exports = {"comic":"content__comic_dBKhh"};


//////////////////
// WEBPACK FOOTER
// ./src/client/components/content/styles.less
// module id = ./src/client/components/content/styles.less
// module chunks = comics